<template>
  <v-list-item two-line :to="`/dialler/${selectedDiallerQueue}/${phoneCall.id}`" :class="{ selected }">
    <v-list-item-avatar class="mr-1" height="24">
      <v-avatar>
        <v-icon v-if="phoneCall.overdue" color="red">fad fa-alarm-exclamation</v-icon>
        <v-icon v-else-if="phoneCall.is_scheduled">fad fa-alarm-clock</v-icon>
        <v-icon v-else color="green">fad fa-phone</v-icon>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="text-uppercase text--primary" v-text="phoneCall.subject.name"></v-list-item-title>
      <v-list-item-subtitle
        :class="{ 'text--primary': phoneCall.subject.contact !== null }"
        v-text="phoneCall.subject.contact || 'No name supplied'"
      ></v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-list-item-action-text
        v-text="phoneCall.friendly_scheduled_time"
        v-if="phoneCall.is_scheduled_for_today"
      ></v-list-item-action-text>
      <v-list-item-action-text v-text="phoneCall.friendly_created_at" v-else></v-list-item-action-text>
      <v-icon small v-if="phoneCall.subject.type === 'Referral'" color="red">fad fa-user-slash</v-icon>
      <v-icon small v-else color="green">fad fa-user</v-icon>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'DiallerCallCard',
  props: {
    phoneCall: Object,
    phoneCallIndex: Number,
    selectedDiallerQueue: String,
    dark: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(['selectPhoneCall'])
  }
};
</script>
<style lang="scss" scoped>
.icon-phone {
  --fa-primary-color: #569700;
  --fa-secondary-color: #88c83d;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 0.8;

  .inactive & {
    --fa-primary-color: #321a32;
    --fa-secondary-color: #5c415b;
  }
}
</style>
